const SEPARATOR = ',';

export const encodeSlugWithId = (str: string, id: number | string) =>
  `${str
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-')}${SEPARATOR}${id}`;

export const decodeSlugWithId = (str: string) => str.split(SEPARATOR).pop()!.match(/(\d*)/)![0];
